import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { IResponseConversationUnread } from 'entities/Conversation/api/types'

export const useEventConversationUnread = (
  handler: (response: IResponseConversationUnread) => void,
  deps: unknown[] = []
) => {
  const { websocket } = useEntitiesContext()
  const _handler = (response: IResponseConversationUnread) => {
    handler(response)
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationUnread, _handler), deps)
}
